import component from './AccountSettings.vue'
export default component
